import { render, staticRenderFns } from "./keyPersonnel.vue?vue&type=template&id=6e3985e9&scoped=true&"
import script from "./keyPersonnel.vue?vue&type=script&lang=js&"
export * from "./keyPersonnel.vue?vue&type=script&lang=js&"
import style0 from "./keyPersonnel.vue?vue&type=style&index=0&id=6e3985e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3985e9",
  null
  
)

export default component.exports